.wrap {
  position: fixed;
  top: calc(var(--space-4) + env(safe-area-inset-top));
  right: var(--space-4);
  left: auto;
  z-index: 120;
  width: min(420px, calc(100vw - 2 * var(--space-4)));
  pointer-events: none;
  transform: translateY(-12px);
  opacity: 0;
  transition: transform 240ms cubic-bezier(0.22, 1, 0.36, 1), opacity 220ms ease;
}

.open { transform: translateY(0); opacity: 1; pointer-events: auto; }

.card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.18), 0 2px 8px rgba(0,0,0,0.08);
  border: 1px solid rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 14px 16px 8px;
}

.headLeft {
  display: flex;
  align-items: center;
  gap: 10px;
}

.check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #2e9d57;
  color: #fff;
}

.checkWarn { background: var(--color-ember); color: #111; }

.warn {
  margin-top: 4px;
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--color-ember-dark);
}

.headTitle {
  font-family: var(--font-display);
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: var(--color-ink);
}

.close {
  background: transparent;
  border: 0;
  cursor: pointer;
  color: var(--color-ink-soft);
  padding: 4px;
  display: flex;
  align-items: center;
}

.close:hover { color: var(--color-ink); }

.body {
  display: grid;
  grid-template-columns: 96px 1fr;
  gap: 12px;
  padding: 6px 16px 14px;
}

.thumb, .thumbPlaceholder {
  width: 96px;
  height: 96px;
  object-fit: cover;
  background: var(--color-bone);
  border-radius: 8px;
}

.details { min-width: 0; display: flex; flex-direction: column; gap: 3px; }

.name {
  font-weight: 700;
  font-size: 1rem;
  color: var(--color-ink);
  line-height: 1.2;
}

.price {
  font-size: 1rem;
  font-weight: 700;
  color: var(--color-ink);
  margin-bottom: 4px;
}

.line {
  font-size: 0.8rem;
  color: var(--color-ink);
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.line span:first-child {
  color: var(--color-ink-soft);
  font-weight: 600;
}

.swatch {
  width: 12px;
  height: 12px;
  border-radius: 2px;
  border: 1px solid rgba(0,0,0,0.15);
  display: inline-block;
}

.actions {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.cta {
  background: var(--color-ember);
  color: #111;
  font-weight: 700;
  letter-spacing: 0.08em;
  padding: 14px 12px;
  text-align: center;
  text-transform: uppercase;
  font-size: 0.78rem;
  border: 0;
  cursor: pointer;
  text-decoration: none;
  transition: background 120ms ease;
}

.cta:hover { background: var(--color-ember-dark); color: #fff; }

.continue {
  background: #4a4441;
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.08em;
  padding: 14px 12px;
  text-align: center;
  text-transform: uppercase;
  font-size: 0.78rem;
  border: 0;
  cursor: pointer;
  font: inherit;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.continue:hover { background: #2c2825; }

@media (max-width: 540px) {
  .wrap { right: 8px; left: 8px; width: auto; top: calc(8px + env(safe-area-inset-top)); }
  .body { grid-template-columns: 72px 1fr; padding: 4px 12px 12px; }
  .thumb, .thumbPlaceholder { width: 72px; height: 72px; }
  .actions { grid-template-columns: 1fr; }
}
